export type WaitlistModalVariant = 'signin' | 'signup';

/** `window` event name — marketing `<Header />` listens and opens the waitlist modal. */
export const REFF_OPEN_WAITLIST_EVENT = 'reff-open-waitlist';

/**
 * When `/login` (or similar) has no Header, set this in sessionStorage and navigate to a page
 * that mounts `<Header showLandingNav />`; Header consumes and opens the modal once.
 */
export const WAITLIST_PENDING_STORAGE_KEY = 'reff-pending-waitlist-open';

export function dispatchOpenWaitlist(variant: WaitlistModalVariant = 'signup') {
  window.dispatchEvent(new CustomEvent(REFF_OPEN_WAITLIST_EVENT, { detail: { variant } }));
}

export function queueWaitlistOpenForNextMarketingHeader(variant: WaitlistModalVariant = 'signup') {
  try {
    sessionStorage.setItem(WAITLIST_PENDING_STORAGE_KEY, variant);
  } catch {
    /* private mode / quota */
  }
}
